
import { Grid } from '@aws-amplify/ui-react';
import { CardMedia, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { connect } from 'react-redux';
import { Branding } from '../../branding';
import { I18n } from '@aws-amplify/core';
import Link from '@material-ui/core/Link';
import Footer from '../../components/Footer/Footer';



const useStyles = makeStyles((theme) => ({
	rootGrid: {
		marginTop: theme.spacing(10),
		paddingBottom: theme.spacing(3),
	},
	grid: {
		justifyContent: 'center',
		direction: "row"
	},
	box: {
		width: '90%',
		maxWidth: 650,
	},
	card: {
		justifyContent: 'center',
		paddingBottom: "16px",
		paddingTop: "16px",
		elevation: 0
	},
	cardMedia: {
		width: 200,
		height: 90,
		backgroundSize: 'contain',
	},
	cardHeader: {
		paddingBottom: 0
	},
	cardContent: {
		"&:last-child": {
			paddingBottom: theme.spacing(1)
		}
	},
	divider: {
		marginBottom: theme.spacing(2)
	},
	typoToS: {
		paddingTop: theme.spacing(3),

	},
	linkTos: {
		fontSize: 12,
		fontWeight: "bold",
		color: Branding.secondary,
		'&:hover': {
			cursor: 'pointer',
			color: Branding.accent,
			opacity: Branding.opacityHover,
		},
	},
	linkToHome: {
		fontSize: 12,
		fontWeight: "bold",
		color: Branding.primary,
		'&:hover': {
			cursor: 'pointer',
			color: Branding.accent,
			opacity: Branding.opacityHover,
		},
	},
	link: {
		fontSize: 12,
		fontWeight: "bold",
		color: Branding.link,
		'&:hover': {
			cursor: 'pointer',
			color: Branding.accent,
			opacity: Branding.opacityHover,
		},
	},
	midBul: {
		paddingLeft: theme.spacing(1),
		paddingRight: theme.spacing(1),
		color: Branding.secondary,
	},
	linkImprint: {
		fontSize: 14,
		'&:hover': {
			cursor: 'pointer',
			color: Branding.accent,
			opacity: Branding.opacityHover,
		},
	},
	subTitle: {
		fontSize: 12,
		fontWeight: "bold",
		color: Branding.lightBlack
	},
	socialPx: {
		minWidth: "20em"
	},
	message: {
		fontWeight: 'bold',
		marginTop: "2em",
		fontSize: "12px",
		color: Branding.primary
	}
}));

const mapStateToProps = (state) => {
	return {
		user: state.app.user,
		lang: state.app.lang,
		tos: state.app.tos
	}
}

const InvalidProviderToChangePassword = (props) => {

	const classes = useStyles();

	return (
		<div>

			<Grid
				container
				spacing={0}
				direction="column"
				alignItems="center"
				justifyContent="center"
				className={classes.rootGrid}>
				<CardMedia
					className={classes.cardMedia}
					image={"https://s3.amazonaws.com/pe-newco-media/wp-content/uploads/2022/07/19122350/YouScience_1320x393_transparent.png"}
					title={Branding.appName} />
			</Grid>

			<Grid container
				direction="column"
				alignItems="center"
				justifyContent="center"
				style={{ marginTop: "1%" }}>
				{

					<Typography style={{
						marginBottom: "2em",
						fontWeight: 'bold',
						marginTop: "2em",
						fontSize: "1em",
						paddingRight: "16px",
						paddingLeft: "16px",
						textAlign: "center",
						color: Branding.primary
					}}> Sorry. You can not modify your {props.provider} password here. Go to your {props.provider} account to change the password.</Typography>
				}

			</Grid>

			<Grid container style={{ justifyContent: 'center' }} className={classes.grid}>
				<div style={{ justifyContent: 'center', textAlign: "center" }}>
					<Typography className={classes.typoToS}>
						<Link
							href="/"
							underline="always"
							className={classes.linkToHome}
						>
							Go to Home
						</Link>
					</Typography>
				</div>
			</Grid>
			<Footer></Footer>

		</div>

	)
}

export default connect(mapStateToProps, {})(InvalidProviderToChangePassword);
